import { AxiosResponse } from 'axios';
import axios from 'axios';
import axiosClient from '../clients/axios-client';
import { GoogleStorageDocument } from '../data/models/companyExternalUser';

interface SignedUrlResponse {
	url: string;
	path: string;
}

interface UploadResponseDTO {
	url: string;
	fileName: string;
	contentType: string;
	size: number;
	uploadedAt: Date;
}

export async function uploadFile(
	file: File,
	path: string,
	token?: string
): Promise<GoogleStorageDocument> {
	const contentType = file.type;

	const graphqlQuery = `
    mutation {
      getSignedUploadUrl(path: "${path}", contentType: "${contentType}")
    }
  `;

	const headers = token
		? {
				Authorization: `Bearer ${token}`,
		  }
		: {};

	const signedUrlResponse: AxiosResponse = await axiosClient({
		url: 'graphql',
		method: 'POST',
		data: {
			query: graphqlQuery,
		},
		headers,
	});

	const signedUrl = signedUrlResponse.data.getSignedUploadUrl;

	// Upload the file to the signed URL
	try {
		// Use plain axios for direct upload to Google Cloud Storage
		// Don't use axiosClient as it has baseURL which breaks external URLs
		await axios({
			url: signedUrl,
			method: 'PUT',
			data: file,
			headers: {
				'Content-Type': contentType,
			},
		});
	} catch (error) {
		console.error('Error uploading file:', error);
		throw error;
	}

	// Return the GoogleStorageDocument object
	return {
		uuid: '', // Backend should provide this
		name: file.name,
		bucket: '', // Backend should provide this
		url: path,
		publicUrl: path, // Assuming public URL is the same as internal URL for now
		mimeType: file.type,
		size: file.size,
		created: new Date().toISOString(),
		updated: new Date().toISOString(),
	};
}

export async function getSignedGetUrl(
	path: string,
	token?: string
): Promise<string> {
	const graphqlQuery = `
    mutation {
      getSignedGetUrl(path: "${path}")
    }
  `;

	const headers = token
		? {
				Authorization: `Bearer ${token}`,
		  }
		: {};

	const response: AxiosResponse = await axiosClient({
		url: 'graphql',
		method: 'POST',
		data: {
			query: graphqlQuery,
		},
		headers,
	});

	return response.data.getSignedGetUrl;
}

export async function deleteFile(
	fileUrl: string,
	token?: string
): Promise<boolean> {
	const graphqlQuery = `
    mutation {
      deleteFile(fileUrl: "${fileUrl}")
    }
  `;

	const headers = token
		? {
				Authorization: `Bearer ${token}`,
		  }
		: {};

	try {
		const response: AxiosResponse = await axiosClient({
			url: 'graphql',
			method: 'POST',
			data: {
				query: graphqlQuery,
			},
			headers,
		});

		return response.data.deleteFile;
	} catch (error) {
		console.error('Error deleting file:', error);
		if (
			typeof error === 'string' &&
			error.toLowerCase().includes('no such object:')
		) {
			return true;
		}
		throw error;
	}
}
